<template>
  <div class="modal-devise ">

    <b-modal ref="deviseModal" centered @hidden="onHiddenModal" :hide-header="true" :hide-footer="true">
      <div class="p-4" v-bind:style= "[this.$store.state.deviseLoading ? { 'min-height': '250px' } : {}]">

        <LoaderContent v-if="this.$store.state.deviseLoading" />

        <button type="button" class="ml-auto close" @click="$refs.deviseModal.hide()">
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <DefineMethod
          v-if="visibleForm == 'define'"
          v-on:changeModal="changeModal"
          v-on:social="social" />

        <LoginForm
          v-if="visibleForm == 'login'"
          v-on:changeModal="changeModal"
          v-on:signIn="signIn"
          v-on:social="social" />

        <InsertCpf
          v-if="visibleForm == 'insert-cpf'"
          v-on:changeModal="changeModal"
          v-on:signIn="signIn"
          v-on:social="social" />

        <PreRegisterForm
          v-if="visibleForm == 'preRegister'"
          v-on:changeModal="changeModal"
          v-on:signIn="signIn"
          v-on:social="social" />

        <UserExists
          v-if="visibleForm == 'userExists'"
          v-on:changeModal="changeModal"
          v-on:signIn="signIn"
          v-on:social="social" />

        <RegisterForm
          v-if="visibleForm == 'register'"
          v-on:changeModal="changeModal"
          v-on:signUp="signUp"
          v-on:social="social" />

        <PasswordForm
          v-if="visibleForm == 'password'"
          v-on:changeModal="changeModal" />

        <ForgotUserForm
          v-if="visibleForm == 'forgotUser'"
          v-on:changeModal="changeModal" />

        <ChangePasswordForm
          v-if="visibleForm == 'change-password'"
          v-on:changeModal="changeModal"
          v-on:signIn="signIn" />

        <DocumentForm
          v-if="visibleForm == 'document'"
          v-on:changeModal="changeModal"
          v-on:signUp="signUp"  />

      </div>
    </b-modal>

  </div>
</template>

<script>
  import CloseIcon from "vue-material-design-icons/Close.vue"
  import DefineMethod from "./DefineMethod.vue"
  import LoginForm from "./Login.vue"
  import PreRegisterForm from "./PreRegister.vue"
  import InsertCpf from "./InsertCpf.vue"
  import RegisterForm from "./Register.vue"
  import PasswordForm from "./Password.vue"
  import ForgotUserForm from "./ForgotUser.vue"
  import ChangePasswordForm from "./ChangePassword.vue"
  import DocumentForm from "./Document.vue"
  import UserExists from "./UserExists.vue"
  import LoaderContent from '@/components/loader/LoaderContent.vue'
  import 'url-search-params-polyfill';

  export default {
    name: 'DeviseModal',

    components: {
      CloseIcon,
      DefineMethod,
      LoginForm,
      PreRegisterForm,
      InsertCpf,
      RegisterForm,
      PasswordForm,
      ForgotUserForm,
      ChangePasswordForm,
      DocumentForm,
      UserExists,
      LoaderContent
    },

    computed: {
      visibleForm(){
        return this.$store.state.deviseForm
      }
    },

    watch: {
      visibleForm: function(newValue, oldValue){
        newValue ? this.$refs.deviseModal.show() : this.$refs.deviseModal.hide()
      }
    },

    beforeMount() {
      const code = new URLSearchParams(window.location.search).get("code");
      const action = new URLSearchParams(window.location.search).get("action");

      if(code){
        const return_url = window.location.origin + '/linkedin-return'
        this.$store.commit('DEVISE_FORM', 'searching');
        this.$store.commit('DEVISE_LOADING', true);

        this.$store.dispatch('user/linkedinProfile', { return_url, code, company: '' }).then( profile => {
          this.flow(action, 'linkedin', profile)
        })
      }
    },

    mounted() {
      if( this.visibleForm ) this.$refs.deviseModal.show()
    },

    methods: {
      onHiddenModal(){
        this.$store.commit('DEVISE_FORM', null);
        this.$store.commit('DEVISE_TRYING', null);
        this.$store.commit('DEVISE_LOADING', false)

        let query = Object.assign({}, this.$route.query);
        delete query.action;
        delete query.code;
        this.$router.replace({ query });
      },

      changeModal(target){
        this.$store.commit('DEVISE_FORM', target);
      },

      social(provider, action){
        action = action || 'register';

        if( provider == 'linkedin' ){
          this.$router.push({
            name: 'linkedin-return',
            query: {
              back_to: `${window.location.pathname}?action=${action}`
            }
          })

        }else if( provider == 'facebook' ){
          this.$store.commit('DEVISE_LOADING', true);

          this.$socialAuth(provider).login({ scope: 'email' }).then( () => {
            this.$socialAuth(provider).api('me').then( (profile) => {
              this.flow(action, provider, profile)
            })
          }, (e) => {
            this.$store.commit('DEVISE_LOADING', false);
          })
        }
      },


      flow(action, provider, profile){
        if(profile.error){
          this.$store.commit('DEVISE_FORM', null);
          this.$store.commit('DEVISE_LOADING', false);
          return
        }

        profile.provider = provider;
        profile.action = action;

        this.$store.commit('DEVISE_TRYING', profile);

        if( action == 'register' ){
          this.$store.commit('DEVISE_FORM', 'document');
        }

        if( action == 'login' ){
          this.signIn()
        }

        this.$store.commit('DEVISE_LOADING', false);
      },


      signUp(){
        this.$store.commit('DEVISE_LOADING', true);
        const { first_name, last_name, email, isForeign, document, password, provider, id, accept_terms_of_use } = this.$store.state.deviseTrying

        const params = {
          first_name: first_name,
          last_name: last_name,
          email: email,
          foreigner: isForeign,
          document: document,
          password: password,
          provider: provider,
          provider_id: id,
          accept_terms_of_use: accept_terms_of_use
        }

        this.$store.dispatch('user/signUp', params).then( async response => {
          if( response.error ){
            this.$swal('Uoops', 'E-mail ou CPF informado já foi cadastrado anteriormente', 'error');
            this.$store.commit('DEVISE_LOADING', false);
          }else{
            this.$store.commit('DEVISE_LOADING', 'complete');

            setTimeout( () => {
              // Tempo para aparecer uma mensagem de complete
              this.$store.commit('DEVISE_FORM', null);
              this.$store.commit('DEVISE_LOADING', false);

              let { path, query, name } = this.$store.state.user.nextRoute;
              if(name == 'ficha'){
                this.$router.push({ path: path, query: query });
              }else{
                this.$router.push(`/vagas`);
              }

            }, 3000)
          }
        });
      },



      signIn() {
        this.$store.commit('DEVISE_LOADING', true);
        const { email, password, keepLogged, provider, id } = this.$store.state.deviseTrying;

        if ("activeElement" in document) document.activeElement.blur();

        const params = {
          email: email,
          password: password,
          keepLogged: keepLogged,
          provider: provider,
          provider_id: id,
          returns: 'id, name, avatar, termsOfUserAccepted{ companyId }'
        }

        this.$store.dispatch('user/signIn', params).then( response => {
          if( response.error ){
            if( response.error.message.indexOf('senha') !== -1 ){
              this.$swal('Uoops', 'E-mail ou senha incorretos', 'error');
              this.$store.commit('DEVISE_LOADING', false)
            }else{
              this.$swal({
                title: 'Uoops',
                text: 'Não encontramos seu usuário. Deseja se cadastrar?',
                type: 'error',
                showCancelButton: true,
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim, quero me cadastrar',
                reverseButtons: true
              }).then((result) => {
                if (result.value) {
                  this.$store.commit('DEVISE_FORM', params.provider ? 'document' : 'register')
                }else if(result.dismiss){
                  this.$store.commit('DEVISE_FORM', 'login')
                }

                this.$store.commit('DEVISE_LOADING', false)
              })
            }
          }else{
            this.$store.commit('DEVISE_LOADING', 'complete')

            setTimeout( () => {
              // Tempo para aparecer uma mensagem de complete
              this.$store.commit('DEVISE_FORM', null)
              this.$store.commit('DEVISE_LOADING', false)

              let { path, query } = this.$store.state.user.nextRoute;
              this.$router.push({ path: path, query: query })
              // this.$store.dispatch('user/companyFollow')
              this.$EventBus.$emit('checkTermsOfUse');
            }, 3000)
          }
        })
      }

    }
  }
</script>

<style lang="scss" scoped>
  .modal-devise{
    position: relative;
    font-size: 14px;

    /deep/ .modal-content{
      border-radius: 16px;
    }

    /deep/ .form-control{
      font-size: inherit;
    }

    /deep/ .btn{
      min-height: 45px;
    }
  }
</style>